import { Box, Typography } from '@mui/material';

const VARIANTS = {
  note: { label: 'Note', color: 'info.main', bg: 'rgba(33,150,243,0.08)' },
  tip: { label: 'Tip', color: 'success.main', bg: 'rgba(76,175,80,0.08)' },
  warning: { label: 'Warning', color: 'warning.main', bg: 'rgba(255,152,0,0.10)' },
  important: { label: 'Important', color: 'error.main', bg: 'rgba(244,67,54,0.08)' },
};

export default function GuideCallout({ variant, children }) {
  const v = VARIANTS[variant] || VARIANTS.note;
  return (
    <Box
      data-testid="guide-callout"
      data-variant={VARIANTS[variant] ? variant : 'note'}
      sx={{
        my: 2,
        p: 2,
        borderLeft: '4px solid',
        borderColor: v.color,
        bgcolor: v.bg,
        borderRadius: 1,
      }}
    >
      <Typography variant="subtitle2" sx={{ color: v.color, mb: 0.5 }}>
        {v.label}
      </Typography>
      <Box sx={{ '& p': { m: 0 } }}>{children}</Box>
    </Box>
  );
}
